import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { getServiceDeskNavigationResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { knowledgeHubSetupRoute } from '@atlassian/jira-router-routes-servicedesk-knowledge-hub-routes/src/knowledgeHubSetupRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import {
	APP_NAMES,
	toPackageName,
} from '@atlassian/jira-servicedesk-common/src/utils/app-names/index.tsx';
import { projectIdResource } from '@atlassian/jira-router-resources-knowledge-hub/src/services/project-id/index.tsx';
import { resourceWithCondition } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import { kbTopicsResource } from '@atlassian/jira-router-resources-knowledge-hub/src/services/kb-topics/index.tsx';
import { knowledgeHubBrowseAllArticlesKBTypeCheckerResource } from '@atlassian/jira-router-resources-knowledge-hub/src/services/kb-type-checker/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { getKnowledgeHubResources } from './common/getKnowledgeHubResources.tsx';
import ServiceDeskKnowledgeHubSetup, {
	LazyServicedeskKnowledgeHubSetup,
} from './ui/setup/index.tsx';
import { getKBExperimentResources } from './common/getKBExperimentResources.tsx';

export const knowledgeHubSetupRouteEntry = createEntry(knowledgeHubSetupRoute, () => ({
	group: 'servicedesk',
	component: ServiceDeskKnowledgeHubSetup,
	layout: serviceProjectLayout,

	navigation: {
		menuId: MENU_ID.PROJECTS,
		sidebar: AsyncSidebarServicedesk,
	},

	resources: [
		...getServiceDeskNavigationResources(),
		...getKnowledgeHubResources(),
		getConsolidationStateResource(),
		...getKBExperimentResources(),
		resourceWithCondition(() => fg('jsm-kb-articles-functional'), projectIdResource),
		resourceWithCondition(() => fg('jsm-kb-articles-functional'), kbTopicsResource),
		resourceWithCondition(
			() => fg('jsm-kb-articles-functional'),
			knowledgeHubBrowseAllArticlesKBTypeCheckerResource,
		),
	],

	forPaint: [LazyAtlassianNavigation, LazyServicedeskKnowledgeHubSetup],

	meta: {
		reporting: {
			id: APP_NAMES.KB_SETUP,
			packageName: toPackageName(APP_NAMES.KB_SETUP),
			teamName: 'jsm-nebula',
		},
	},

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-servicedesk-knowledge-hub-entries/src/knowledgeHubSetupRouteEntry.tsx',
			whichExportToUse: 'knowledgeHubSetupRouteEntry',
		},

		enabled: true,
	},
}));
